'use strict';

import {footerElements} from "./elements/footerElements";

export default class Footer
{
    constructor() {
        this.elements = footerElements();
        this.windowResize = this.onWindowResize.bind(this);
        this.addEventListeners();
        this.sizeFooter();
    }

    addEventListeners() {
        window.addEventListener('resize', this.windowResize);
        window.addEventListener('load', this.windowResize);
    }

    sizeFooter() {
        const footerHeight = this.elements.footer.getBoundingClientRect().height;
        this.elements.body.style.paddingBottom = `${footerHeight+20}px`;
    }

    onWindowResize() {
        this.sizeFooter();
    }
}
